/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.SITECORE_API_KEY || '3C3A9934-7730-4066-A3CF-F7CBC84D16C0';
config.sitecoreApiHost = process.env.SITECORE_API_HOST || 'https://prod104-xsf.dpxmedcity.net';
config.sitecoreSiteName = process.env.SITECORE_SITE_NAME || 'oas';
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || '/sitecore/api/graph/edge';
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || 'en-US';
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || 'https://prod104-xsf.dpxmedcity.net/sitecore/api/graph/edge';
config.layoutServiceConfigurationName = process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || 'sxa-jss';
config.publicUrl = process.env.PUBLIC_URL || 'https://wwwprod104-oas-sitecore-cloud.dpxmedcity.net/physicians';
config.mhoUrl = process.env.MHO_URL || 'https://wwwprod-mho104-sitecore-cloud.dpxmedcity.net';
module.exports = config;